import { render, staticRenderFns } from "./detaile.vue?vue&type=template&id=cdbfd416&scoped=true&"
import script from "./detaile.vue?vue&type=script&lang=js&"
export * from "./detaile.vue?vue&type=script&lang=js&"
import style0 from "./detaile.vue?vue&type=style&index=0&id=cdbfd416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbfd416",
  null
  
)

export default component.exports